var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "forget" },
    [
      _c("div", { staticClass: "forget-head-border" }, [
        _c("img", {
          staticClass: "logo_img",
          attrs: { src: require("@/assets/img/shopvidi_logo.png") },
          on: { click: _vm.gotoShopvidi }
        })
      ]),
      _vm._v(" "),
      _c(
        "el-steps",
        { attrs: { active: _vm.currentTab, "finish-status": "success" } },
        [
          _c("el-step", { attrs: { title: "E-mail verification" } }),
          _vm._v(" "),
          _c("el-step", { attrs: { title: "Password" } }),
          _vm._v(" "),
          _c("el-step", { attrs: { title: "Complete" } })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "forget-body" },
        [
          _vm.currentTab === 0
            ? _c("step2", { on: { nextStep: _vm.nextStep } })
            : _vm._e(),
          _vm._v(" "),
          _vm.currentTab === 1
            ? _c("step3", {
                attrs: { userInfo: _vm.userInfo },
                on: { nextStep: _vm.nextStep, prevStep: _vm.prevStep }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.currentTab === 2
            ? _c("step4", {
                attrs: { userInfo: _vm.userInfo },
                on: { prevStep: _vm.prevStep, finish: _vm.finish }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-553ec0b4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-553ec0b4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/forget/index.vue
// module id = 8EUI
// module chunks = 2